import { List } from 'immutable';

import { createObjectSelector } from 'app/selectors';

export const aisVersionList = createObjectSelector((state) =>
  state.aisVersions.get('list', List()),
);
